<template>
  <v-card flat>
    <v-card-text>
      <v-form
        ref="form"
        v-model="valid">
        <div class="d-flex">
          <v-flex
            xl2
            md2
            class="mt-2">
            User Token <span class="error--text">*</span>
          </v-flex>
          <v-flex
            xl6
            md8>
            <div class="flex flex-col items-end ">
              <v-text-field
                v-model="form.token"
                :rules="tokenRules"
                autofocus
                class="w-full"
                outlined
                dense
                @input="debounceCheckToken($event)">
                <template #append>
                  <v-fade-transition>
                    <div class="mt-1">
                      <v-img
                        v-if="icon"
                        :src="icon"
                        height="16"
                        eager
                        contain />
                    </div>
                  </v-fade-transition>
                </template>
              </v-text-field>
              <save-change-button
                :state="state"
                :disabled="!valid || !validToken"
                @click="submit()" />
            </div>
          </v-flex>
        </div>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import { CHECK_PEAKTOKEN, UPDATE_SETTING } from '@/resources/graphql'

export default {
  data () {
    return {
      state: 'ready',
      valid: false,
      submitting: false,
      checking: false,
      checkState: 'ready',
      form: {
        token: ''
      },
      tokenRules: [
        (v) => !!v || 'กรุณากรอกข้อมูล'
      ]
    }
  },
  computed: {
    validToken () {
      return this.checkState === 'success'
    },
    icon () {
      switch (this.checkState) {
      case 'success':
        return `${process.env.VUE_APP_ROUTE_PREFIX}imgs/icon/correct_icon.gif?fid=${ Math.random(10000) }`
      case 'error':
        return `${process.env.VUE_APP_ROUTE_PREFIX}imgs/icon/incorrect_icon.gif?fid=${ Math.random(10000) }`
      default: return null
      }
    }
  },
  created () {
    this.debounceCheckToken = this.$_.debounce(this.checkToken, 800)
  },
  methods: {
    checkToken (token) {
      if (!token) {
        this.checkState = 'ready'
        return
      }
      this.$apollo.mutate({
        mutation: CHECK_PEAKTOKEN,
        variables: {
          input: {
            accessToken: token
          }
        }
      }).then(({ data: { peakAccountCheckToken } }) => {
        if (peakAccountCheckToken.success) {
          this.checkState = 'success'
        } else {
          this.checkState = 'error'
        }
      })
    },
    submit () {
      if (!this.$refs.form.validate() || !this.validToken) return

      this.submitting = true
      this.state = 'loading'
      this.$apollo.mutate({
        mutation: UPDATE_SETTING,
        variables: {
          input: {
            peakAccountToken: this.form.token
          }
        }
      }).then(({ data: { updateSetting } }) => {
        if (this.$_.isEmpty(updateSetting.errors)) {
          this.state = 'success'
          this.$emit('next', updateSetting)
        } else {
          this.state = 'error'
        }
      }).finally(() => {
        this.submitting = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
